var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareAndroidSvgrepo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5316 19.4517L16.2723 14.1047H23.7102C23.7102 16.1929 22.8777 18.0834 21.5316 19.4517Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5851 10.8639C21.5851 6.68763 18.255 3.30206 14.1472 3.30206V10.8639H21.5851Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45902 13.0245C2.45902 17.7975 6.26481 21.6666 10.9595 21.6666C13.3068 21.6666 15.4319 20.6994 16.9703 19.1355L10.9595 13.0245V4.38232C6.26481 4.38232 2.45902 8.25155 2.45902 13.0245Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareAndroidSvgrepo);
export default __webpack_public_path__ + "static/media/share-android-svgrepo.7306b2bc727f011ef6d2d83d1b243054.svg";
export { ForwardRef as ReactComponent };